// extracted by mini-css-extract-plugin
module.exports = {"content":"AttachmentToastContent_content__iBgk4","icon":"AttachmentToastContent_icon__t6QIy","message":"AttachmentToastContent_message__2Mc8l"};